<!-- @veltra/icons generated sha256:ec603508a8b0b9ee gen:8 source:src/svg/normal/caret-top.svg -->
<script setup lang="ts">
defineOptions({ name: 'CaretTop' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M14.52 11.35 8.35 4.19c-.18-.2-.52-.2-.7 0l-6.17 7.16c-.23.27-.02.66.35.66h12.34c.37 0 .58-.39.35-.66"
    />
  </svg>
</template>
